import { get } from 'lodash/fp';
import selectProductForItem from './selectProductForItem';

export default itemId => (dispatch, getState) => {
  const { estimateBuilder } = getState();

  const item = get(`entities.items.byId.${itemId}`)(estimateBuilder);
  const designId = get('designId')(item);
  const productSku = get('itemProduct.skuNumber')(item);

  localStorage.setItem(`productToBeSwapped-${designId}`, productSku);

  return dispatch(selectProductForItem(itemId));
};
